var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.care_vital_sign.care_has_vital_signs.length > 0)?_c('div',[_c('p',{class:[
      'm-0 text-thirteen upper-text',
      _vm.item.description == 'PASTOSA' && 'color-orange',
      _vm.item.description == 'EM CÍBALOS' && 'color-orange',
      _vm.item.description == 'BEM MOLDADAS' && 'color-green',
      _vm.item.description == 'AUSENTE' && 'color-red',
      _vm.item.description == 'LÍQUIDA' && 'color-red' ]},[_vm._v(" "+_vm._s(_vm.item.description)+" ")]),_c('p',{staticClass:"mb-1 worksansr text-twelve upper-text"},[_vm._v(" CADASTRADO POR: "+_vm._s(_vm.item.user_name)+" ")]),_c('hr')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }